export const brandValues = [
  {
    icon: 'ri-focus-3-line',
    title: '以议题为单位',
    desc: '比起追逐单条热点，我们更愿意把一个问题的来龙去脉讲清楚，让读者看完能形成自己的判断。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '呈现多方说法',
    desc: '对尚未定论的争议，我们同时保留不同立场的声音，并明确标注哪些部分尚无结论。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '守住表达边界',
    desc: '不作未经核实的指控，不披露与议题无关的个人信息，把讨论聚焦在行为与规则本身。',
  },
  {
    icon: 'ri-tools-line',
    title: '给出可行方法',
    desc: '每篇内容都尽量落到"可以怎么做"，让读者在情绪之外，拿到能立即使用的处理思路。',
  },
];

export const testimonials = [
  {
    name: '陈女士',
    role: '消费者',
    quote:
      '之前遇到预付卡的问题一直不知道该找谁，看了指南里的流程才明白要先把证据整理好，后面沟通顺畅了很多。',
  },
  {
    name: '林先生',
    role: '长期读者',
    quote:
      '我最喜欢的是它不夸张，一个议题会把各方说法都摆出来，而不是只讲一面。读完能自己想明白。',
  },
  {
    name: '周同学',
    role: '内容从业者',
    quote:
      '选题贴近日常生活，租房、退费、装修这些场景都能对上号。把复杂的事情讲清楚，其实很不容易。',
  },
];

export const milestones = [
  { time: '起步阶段', title: '从一个生活场景出发', desc: '最初只是想把自己踩过的坑整理出来，方便身边的朋友少走弯路。' },
  { time: '内容成型', title: '从个案到议题', desc: '逐渐把零散的经历归纳成可以复用的议题方法，形成分类追踪的结构。' },
  { time: '持续更新', title: '跟进事件脉络', desc: '对仍在发展中的议题，用时间线的方式补充进展，让读者看到完整过程。' },
  { time: '面向读者', title: '让方法可以被使用', desc: '不断把内容从"描述现象"推进到"给出可操作的建议"，贴近真实需要。' },
];

export const contactInfo = [
  { icon: 'ri-mail-line', label: '联系邮箱', value: 'contact@ruicha-observer.com' },
  { icon: 'ri-chat-3-line', label: '线索反馈', value: 'tips@ruicha-observer.com' },
  { icon: 'ri-time-line', label: '回复时间', value: '工作日 1-2 个工作日内' },
];